// extracted by mini-css-extract-plugin
module.exports = {"title":"InvestEtFsTypes_title__rdzn4","cardShadow":"InvestEtFsTypes_cardShadow__oKLOj","content":"InvestEtFsTypes_content__m9xHr"};